import { render, staticRenderFns } from "./DeclarationOfSecurity.vue?vue&type=template&id=fc465124&scoped=true&"
import script from "./DeclarationOfSecurity.vue?vue&type=script&lang=js&"
export * from "./DeclarationOfSecurity.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationOfSecurity.vue?vue&type=style&index=0&id=fc465124&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc465124",
  null
  
)

export default component.exports